module.exports = __webpack_public_path__ + "img/resource_pkg4.4b013131.png";